const actionTypes = {
    GET_PROFILE_FULL_DATA: "GET_PROFILE_FULL_DATA",
    MODIFY_ACTIVITIES: "MODIFY_ACTIVITIES",
};

export default actionTypes;
